

<div>

    <label i18n="@@jraapASAF" class="textColour">Associate Schedule & Filters</label>

</div>

<div style="margin-top: 25px;">
    <form novalidate [formGroup]="templatecreationmaster">

      <div class="row topRowMargins">
        <div class="col-lg-1"></div>
        <div class="col-lg-10">
          <mat-form-field appearance="outline">
            <mat-label>Template Name</mat-label>
            <input matInput type="text" formControlName="templatename" [(ngModel)]="templateName" readonly>
          </mat-form-field>
        </div>
        <div class="col-lg-1"></div>
      </div>

        <div class="row topRowMargins">
            <div class="col-lg-1"></div>
            <div class="col-lg-10">
              <mat-form-field appearance="outline">
                <mat-label>Report Name</mat-label>
                <input matInput type="text" formControlName="reportname" [(ngModel)]="templateCreationData.reportName" required>
                <mat-error *ngFor="let validation of validation_messages.reportname">
                  <span *ngIf="templatecreationmaster.get('reportname').hasError(validation.type) && (templatecreationmaster.get('reportname').dirty || templatecreationmaster.get('reportname').touched)">{{validation.message}}</span>
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg-1"></div>
        </div>

        <div class="row topRowMargins">
            <div class="col-lg-1"></div>
            <div class="col-lg-10" style="text-align: center;">
              <mat-form-field appearance="outline">
                <mat-label>Select Schedule</mat-label>
                <input matInput type="text" formControlName="selectschedule" (click)="selectSchedulerClick()" [(ngModel)]="selectSchedule" required readonly>
                 <mat-error *ngFor="let validation of validation_messages.selectschedule">
                  <span *ngIf="templatecreationmaster.get('selectschedule').hasError(validation.type) && (templatecreationmaster.get('selectschedule').dirty || templatecreationmaster.get('selectschedule').touched)">{{validation.message}}</span>
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg-1"></div>
        </div>

        <div class="row topRowMargins">
          <div class="col-lg-1"></div>
          <div class="col-lg-10" style="text-align: center;">
            <mat-form-field appearance="outline">
              <mat-label i18n="@@TMclassifiedserviceType">Select Filter</mat-label>
              <input matInput type="text" (click)="selectFilter()"
              [(ngModel)]="selectfilter" formControlName="selectdataSet" readonly >
             <!-- <mat-error *ngIf="templatecreationmaster.get('selectfilter')?.hasError('mandatoryFilter') 
                  && (templatecreationmaster.get('selectfilter')?.dirty 
                      || templatecreationmaster.get('selectfilter')?.touched)">
                      Please select all mandatory filters.
                    </mat-error> -->
            </mat-form-field>
          </div>
          <!-- <div class="col-lg-10" style="text-align: center;">
              <mat-form-field appearance="outline">
                  <mat-label i18n="@@RCselectfilter">Select Filter</mat-label>
                  <mat-select [(ngModel)]="selectfilter" (selectionChange)="bindSelectFilter($event.value)" formControlName="selectfilter" multiple>
                    
                      <mat-option *ngFor="let filterdropdown of filterstable" [value]="filterdropdown.filtermanageId">
                          {{filterdropdown.filtername}}
                      </mat-option>
                  </mat-select>
              </mat-form-field>
          </div> -->
          <div class="col-lg-1"></div>
      </div>
      
    </form>
    <div class="col-lg">
        <div class="container" style="text-align: center;">
          <div class="row topRowMargins">

            <div class="col-lg">

              <div style="text-align: end">

                <button id="saveBtn" i18n="@@TMRunButton" type="button" (click)="save()" [style.background-color]="backgroundColorButton"
                class="btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" style="padding: .3rem 1.6rem;" [style.background-color]="backgroundColorButton">Save</button>

                <button i18n="@@TMRunButton" type="button" (click)="cancel()" [style.border-color]="backgroundColorButton"
                class="cancelButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" style="padding: .3rem 1.6rem;" [style.border-color]="backgroundColorButton">Cancel</button>

              </div>

            </div>

          </div>
        </div>
      </div>
</div>


  <!-- 🔹 Your side panel (initially hidden) -->
    <!-- <div class="drawer-content container" >
    
      <div id="sidePanel" [class.open]="showSidePanel" class="side-panel">
        <div class="panel-header">
          <span class="close-btn" (click)="closeSidePanel()">×</span>
        </div>
    
        <div *ngIf="selectedFilterDetails">
          <table>
          <thead class="table-heading">
            <tr>
            <th class="th-lg text-left">Label</th>
            <th class="th-lg text-left">Condition</th>
            <th class="th-lg text-left">Value</th>
          </tr>
        </thead>
        <tbody style="border:none;">
            <td text-left>{{ selectedFilterDetails[0].label }}</td>
            <td text-left>{{ selectedFilterDetails[0].whereCondition }}</td>
            <td>{{selectedFilterDetails[0].whereValue}}</td>
        </tbody>
      </table>
        </div>
      </div> -->
      <!-- <div class="row" style="padding: 0; margin: 0;">
        <div id="table-responsive" style="margin: 0; padding: 0;">
        <table *ngIf="selectedFilterDetails">
          <caption></caption>
          <thead class="table-heading">
          <tr>
          <th class="th-lg text-left">Label</th>
          <th class="th-lg text-left">Condition</th>
          <th class="th-lg text-left">Value</th>
        </tr>
        </thead>
          <tbody style="border:none;">
            <tr *ngFor="let item of selectedFilterDetails">
              <td text-left>{{ item.label }}</td>
              <td text-left>{{ item.whereCondition }}</td>
              <td><a href="#" onclick="openPanel(selectedFilterDetails)">{{item.whereValue}}</a></td>
            </tr>
          </tbody>
        </table>
    </div>  -->
    <!-- <div class="side-panel" id="sidePanel">
      <span class="close-btn" onclick="closePanel()">✖</span>
      <div class="content-header">Details</div>
      <div id="panelContent"></div>
    </div>   -->
    <!-- </div>  -->
  <!-- </div> -->
<!-- <div class="drawer-header">
  <button (click)="drawer.close(); showSidePanel = false" class="cancelButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize close-btn" style="padding: .3rem 1.6rem;" [style.border-color]="backgroundColorButton">
    Close
  </button>
</div> -->
  
<div class="agGridOuterDiv" *ngIf="agGridShow">

        <mat-toolbar class="agGridtoperDiv card" style="
            background: rgb(228 227 230 / 41%);border-top: 1px solid #a9a9a9a8;
    border-right: 1px solid #a9a9a9a8;
    border-left: 1px solid #a9a9a9a8;">
                         <span class="example-spacer"></span>
                        <button class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="backgroundColorButton" title="Download" (click) = "onBtExport()">Download
                                <em style="padding: 0px 0px 0px 10px;" class="fas fa-download example-icon" title="Download"></em>
                        </button>
                        <div class="insertPageNoDiv">
                            <mat-form-field appearance="outline">
                                <mat-label i18n="@@Targetpageno">Page No</mat-label>
                                <input matInput type="text" (input)="onSearchChange($event.target.value)">
                            </mat-form-field>
                        </div>
                        <div class="selectRecordsDiv" style="width:9.5%">
                            <mat-form-field appearance="outline" style="width:100%">
                                <mat-label i18n="@@Targetrecords" style="color:black">Records</mat-label>
                                <mat-select [(ngModel)]="pageSize" (ngModelChange)="onPageSizeChanged(value)">
                                    <mat-option value="10" selected>10</mat-option>
                                    <mat-option value="200">200</mat-option>
                                    <mat-option value="300">300</mat-option>
                                    <mat-option value="400">400</mat-option>
                                </mat-select>

                            </mat-form-field>
                        </div>
                        <div class="card pagination paginationFirstButton paginationFirstlastButton">
                            <em class="fas fa-angle-double-left waves-effect waves-light" (click)="onBtFirst()"></em>
                        </div>
                        <div class="card pagination paginationButtons btn-rounded">
                            <ul>
                                <li class="paginationliicon"><em class="fas fa-angle-left waves-effect waves-light"
                                        (click)="onBtPrevious()"></em></li>
                                <li>{{currentPage}}/{{totalPages}}</li>
                                <li class="paginationliicon" style="padding:0;"><em
                                        class="fas fa-angle-right waves-effect waves-light" (click)="onBtNext()"></em></li>
                            </ul>
                        </div>
                        <div class="card pagination paginationLastButton paginationFirstlastButton">
                            <em class="fas fa-angle-double-right waves-effect waves-light" (click)="onBtLast()"></em>
                        </div>

            </mat-toolbar>
  
    <div class="ag-grid-wrapper">
        <ag-grid-angular class="ag-theme-balham ag-main-grid table-width tablestyles square scroolbar-dusty-grass square thin" [ngClass]="{ 'shrinked': showSidePanel }"
        [columnDefs]="columnDefs" [animateRows]="true" [pagination]="true"
        [rowSelection]="rowSelection" [defaultColDef]="defaultColDef" [suppressPaginationPanel]="true" [rowHeight]="35"
        [headerHeight]="35" [enableBrowserTooltips]="true" [floatingFiltersHeight]="45" 
        [paginationPageSize]="paginationPageSize" [paginationNumberFormatter]="paginationNumberFormatter"
        [enableRangeSelection]="true" [components]="components" [debug]="true" [rowClassRules]="rowClassRules"
        (paginationChanged)="onPaginationChanged()"
        (gridReady)="onGridReady($event)" (cellDoubleClicked)="retrieveRequestDetails($event)" [hidden]="!true"></ag-grid-angular>
      
    
      <div id="sidePanel" [class.open]="showSidePanel" class="side-panel"  [ngClass]="{ open: showSidePanel }">
                
        <ag-grid-angular
        
          class="ag-theme-balham ag-details-grid table-width tablestyles square scroolbar-dusty-grass square thin"
          style="width: 100%;"
          [rowData]="selectedFilterDetails"
          [columnDefs]="drawerColumnDefs"
          [defaultColDef]="defaultColDef"
          [rowHeight]="35"
          [headerHeight]="35"
          [floatingFiltersHeight]="45"
          [domLayout]="'autoHeight'"
          [suppressPaginationPanel]="true"
          (gridReady)="onSideGridReady($event)"
          >
        </ag-grid-angular>
        <div class="panel-header">
          <span class="close-btn" (click)="closeSidePanel()" class="cancelButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize close-btn" style="padding: .3rem 1.6rem;" [style.border-color]="backgroundColorButton">Close</span>
          <div id="panelContent"></div>
        </div>
      </div>
    </div>
</div>